import React from 'react';
import { Ship } from 'lucide-react';

export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-[var(--primary-bg)] flex flex-col items-center justify-center">
      <Ship className="w-12 h-12 text-[var(--accent-color)] mb-4 animate-bounce" />
      <div className="text-[var(--secondary-text)]">
        Loading Weather Explorer...
      </div>
    </div>
  );
}